import React, { useEffect, useState } from "react";
import { useNavigate, useParams,useSearchParams } from "react-router-dom";
import { observer } from "mobx-react";
import IndustryRecruitment from "./component/industry-recruitment";
import CompanyRecruitment from "./component/company-recruitment";

import "./scss/index.scss";
import CityRecruitment from "./component/city-recruitment";
import RoleRecruitment from "./component/role-recruitment";
import HotRoleRecruitment from "./component/hotrole-recruitment";
import { demandInit } from "./store";
import moIndex from "../store";
import { toggleValue } from "@/store";
import { newUrl } from '@/tool';

interface IProps {}
interface IState {}

// 人力需求
const HumanDemand = (props: IProps, state: IState) => {
  const navi = useParams();
  const [searchParams] = useSearchParams();
  const industryCode = searchParams.get('industryCode');
  const categoryName = searchParams.get('categoryName');
  const { industry } = moIndex;

  const init = async () => {
    toggleValue("isLoading", true);
    await demandInit();
    const industry: any = document.getElementById("industry");
    const company: any = document.getElementById("company");
    const city: any = document.getElementById("city");
    const role: any = document.getElementById("role");
    const hotrole: any = document.getElementById("hotrole");
    if (navi.id === "0") {
      const top = industry.offsetTop;
      window.scrollTo(0, 0);
    }
    if (navi.id === "1") {
      const top = industry.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "2") {
      const top = company.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "3") {
      const top = city.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "4") {
      const top = role.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "5") {
      const top = hotrole.offsetTop;
      window.scrollTo(0, top + 90);
    }
    toggleValue("isLoading", false);
    setTimeout(() => {
      toggleValue("isLoading", false);
    }, 5000);
  };

  const goEffect = () => {
    window.location.href = "/market/insight";
  };

  useEffect(() => {

    // if (industry.code) {
      newUrl({title:'人力核心指标_人才需求',industryName: categoryName || industry.name,industryCode:industryCode|| industry.code},['title','industryName'])
      init();
    // }
    return () => {};
  }, []);
  useEffect(() => {

    const doc_industry: any = document.getElementById("industry");
    const company: any = document.getElementById("company");
    const city: any = document.getElementById("city");
    const role: any = document.getElementById("role");
    const hotrole: any = document.getElementById("hotrole");
    // newUrl({title:'人力核心指标_人才需求',industryName: categoryName || industry.name,industryCode:industryCode|| industry.code},['title','industryName'])
    if (navi.id === "0") {
      const top = doc_industry.offsetTop;
      window.scrollTo(0, 0);
    }
    if (navi.id === "1") {
      const top = doc_industry.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "2") {
      const top = company.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "3") {
      const top = city.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "4") {
      const top = role.offsetTop;
      window.scrollTo(0, top + 90);
    }
    if (navi.id === "5") {
      const top = hotrole.offsetTop;
      window.scrollTo(0, top + 90);
    }
   
    return () => {

    };
  }, [document.title]);

  return (
    <section className="human-demand-warp">
      <IndustryRecruitment />
      <CompanyRecruitment />
      <section className="human-huring-banner" onClick={goEffect}>
        <img
          src="https://file.smartsalary.cn/web-img%402.0/home/1012.png"
          alt=""
        />
        <img
          src="https://file.smartsalary.cn/web-img%402.0/home/1010.png"
          alt=""
        />
      </section>
      <CityRecruitment />
      <RoleRecruitment />
      <HotRoleRecruitment />
    </section>
  );
};

export default observer(HumanDemand);
